module.exports = "/app/user/img/PLATINUM.530aeaaf.png";